import { ca } from '@cian/analytics';

export function trackWatchVideoClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click_sopr',
    label: 'how_to_deal',
  });
}
